import { ApolloLink } from './ApolloLink';

export const split = ApolloLink.split;



// WEBPACK FOOTER //
// ../../../src/link/core/split.ts